/* ============================================================
   JP PREMIUM JS v3 - Jori Papel
   Dark Premium interactions - iOS Safari safe
   ============================================================ */

(function () {
  'use strict';

  /* ---- Scroll Progress Bar ---- */
  var progressBar = document.createElement('div');
  progressBar.id = 'jp-scroll-progress';
  document.body.prepend(progressBar);

  function updateProgressBar() {
    var scrolled = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight) * 100;
    progressBar.style.width = Math.min(scrolled, 100) + '%';
  }

  /* ---- Header Sticky Dark ---- */
  var header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');

  function handleHeaderScroll() {
    if (!header) return;
    if (window.scrollY > 60) {
      header.classList.add('jp-scrolled');
      var hw = header.querySelector ? header.querySelector('.header-wrapper') : header;
      if (hw) hw.classList.add('jp-scrolled');
    } else {
      header.classList.remove('jp-scrolled');
      var hw2 = header.querySelector ? header.querySelector('.header-wrapper') : header;
      if (hw2) hw2.classList.remove('jp-scrolled');
    }
  }

  /* Combine scroll listeners — throttled via rAF for mobile perf */
  var scrollTicking = false;
  window.addEventListener('scroll', function() {
    if (!scrollTicking) {
      scrollTicking = true;
      requestAnimationFrame(function() {
        updateProgressBar();
        handleHeaderScroll();
        scrollTicking = false;
      });
    }
  }, { passive: true });

  updateProgressBar();
  handleHeaderScroll();

  /* ---- IntersectionObserver - Scroll Reveal ---- */
  function initScrollReveal() {
    /* Fallback for browsers without IntersectionObserver (old iOS Safari) */
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.jp-reveal').forEach(function(el) {
        el.classList.add('jp-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('jp-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px'
    });

    var selectors = [
      '.jp-reveal',
      '.jp-beneficio-card',
      '.jp-depoimento-card',
      '.jp-feature-card',
      '.card-wrapper',
      '.multicolumn-list__item',
    ].join(', ');

    document.querySelectorAll(selectors).forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9) {
        /* Already visible - show immediately */
        el.classList.add('jp-reveal', 'jp-visible');
      } else {
        el.classList.add('jp-reveal');
        observer.observe(el);
      }
    });
  }

  /* ---- Smooth Scroll for anchors - iOS Safari safe ---- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(a) {
      a.addEventListener('click', function(e) {
        var href = a.getAttribute('href');
        if (!href || href === '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        /* Use scrollIntoView with polyfill approach for iOS */
        var top = target.getBoundingClientRect().top + window.pageYOffset - 80;
        try {
          window.scrollTo({ top: top, behavior: 'smooth' });
        } catch(err) {
          /* Fallback for very old iOS */
          window.scrollTo(0, top);
        }
      });
    });
  }

  /* ---- Image hover overflow fix ---- */
  function initImageEnhancement() {
    document.querySelectorAll('.card__media, .banner__media').forEach(function(el) {
      el.style.overflow = 'hidden';
    });
  }

  /* ---- Counter Animation for stats ---- */
  function animateCounter(el) {
    var raw = el.getAttribute('data-count') || el.textContent.replace(/[^0-9]/g, '');
    var target = parseInt(raw, 10);
    if (isNaN(target) || target === 0) return;
    var duration = 1500;
    var start = null;
    function update(ts) {
      if (!start) start = ts;
      var elapsed = ts - start;
      var progress = Math.min(elapsed / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(target * eased).toLocaleString('pt-BR');
      if (progress < 1) requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
  }

  function initCounters() {
    if (!('IntersectionObserver' in window)) return;
    var counterObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-count], .jp-stat-number, .jh-stat-n').forEach(function(el) {
      counterObserver.observe(el);
    });
  }

  /* ---- Ripple Effect on Buttons ---- */
  function initRipple() {
    document.querySelectorAll('.button, .btn, .jh-btn-wa').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        var ripple = document.createElement('span');
        var rect = btn.getBoundingClientRect();
        var size = Math.max(rect.width, rect.height);
        var x = e.clientX - rect.left - size / 2;
        var y = e.clientY - rect.top - size / 2;

        ripple.style.cssText = [
          'position:absolute',
          'border-radius:50%',
          'background:rgba(255,255,255,0.35)',
          'width:' + size + 'px',
          'height:' + size + 'px',
          'left:' + x + 'px',
          'top:' + y + 'px',
          'transform:scale(0)',
          'animation:jpRipple 0.6s ease-out forwards',
          'pointer-events:none',
          'z-index:0'
        ].join(';');

        var pos = window.getComputedStyle(btn).position;
        if (pos === 'static') btn.style.position = 'relative';
        btn.style.overflow = 'hidden';
        btn.appendChild(ripple);
        setTimeout(function() { if (ripple.parentNode) ripple.remove(); }, 700);
      });
    });

    if (!document.getElementById('jp-ripple-style')) {
      var s = document.createElement('style');
      s.id = 'jp-ripple-style';
      s.textContent = '@keyframes jpRipple { to { transform: scale(4); opacity: 0; } }';
      document.head.appendChild(s);
    }
  }

  /* ---- Active Nav ---- */
  function initActiveNav() {
    var currentPath = window.location.pathname;
    document.querySelectorAll('.header__menu-item a, .header__menu-item .link').forEach(function(link) {
      if (link.getAttribute('href') === currentPath) {
        link.classList.add('header__active-menu-item');
      }
    });
  }

  /* ---- WA Tooltip auto-hide ---- */
  function initWaTooltip() {
    var t = document.getElementById('jpWaTooltip');
    if (!t) return;
    setTimeout(function() {
      t.style.transition = 'opacity 0.5s';
      t.style.opacity = '0';
      setTimeout(function() { t.style.display = 'none'; }, 500);
    }, 8000);
  }

  /* ---- INIT ---- */
  function init() {
    initScrollReveal();
    initSmoothScroll();
    initImageEnhancement();
    initCounters();
    initRipple();
    initActiveNav();
    initWaTooltip();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* ── REDESIGN 2026 — Header transparente com blur no scroll ── */
(function() {
  var header = document.querySelector('header, .header, .site-header');
  if (!header) return;

  var onScroll = function() {
    if (window.scrollY > 60) {
      document.documentElement.classList.add('header-scrolled');
    } else {
      document.documentElement.classList.remove('header-scrolled');
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // run on load
})();

// === ELIMINAR ESPAÇO ACIMA DO HERO ===
(function() {
  function fixHeroSpacing() {
    // Zerar margin/padding da section que contém o hero
    var heroSection = document.querySelector('.jh-section');
    if (heroSection) {
      var parentSection = heroSection.closest('.shopify-section');
      if (parentSection) {
        parentSection.style.cssText += 'margin:0!important;padding:0!important;';
      }
      // Também zerar o main content
      var main = document.getElementById('MainContent') || document.querySelector('main');
      if (main) {
        main.style.cssText += 'margin-top:0!important;padding-top:0!important;';
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixHeroSpacing);
  } else {
    fixHeroSpacing();
  }
})();



/* ============================================================
   THEME TOGGLE (dark/light) — Jori v4
   Default: light. User pode optar por dark via botão.
   Persistência: localStorage 'jp-theme' = 'dark' | 'light'
   FOUC-safe: aplica preferência no <head> via inline script no theme.liquid
   ============================================================ */
(function() {
  'use strict';

  var STORAGE_KEY = 'jp-theme';
  var html = document.documentElement;

  // Aplicar tema persistido (caso script inline do head não tenha rodado por algum motivo)
  try {
    var saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'dark') {
      html.setAttribute('data-theme', 'dark');
    } else {
      html.removeAttribute('data-theme');
    }
  } catch (e) { /* ignore */ }

  // SVGs dos ícones (sun e moon)
  var SUN_SVG = '<svg class="jp-theme-icon-sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="M4.93 4.93l1.41 1.41"/><path d="M17.66 17.66l1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="M4.93 19.07l1.41-1.41"/><path d="M17.66 6.34l1.41-1.41"/></svg>';
  var MOON_SVG = '<svg class="jp-theme-icon-moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>';

  function createToggle() {
    var btn = document.createElement('button');
    btn.className = 'jp-theme-toggle';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Alternar tema claro / escuro');
    btn.setAttribute('title', 'Alternar tema');
    btn.innerHTML = SUN_SVG + MOON_SVG;
    btn.addEventListener('click', toggleTheme);
    return btn;
  }

  function toggleTheme() {
    var isDark = html.getAttribute('data-theme') === 'dark';
    if (isDark) {
      html.removeAttribute('data-theme');
      try { localStorage.setItem(STORAGE_KEY, 'light'); } catch (e) {}
    } else {
      html.setAttribute('data-theme', 'dark');
      try { localStorage.setItem(STORAGE_KEY, 'dark'); } catch (e) {}
    }
  }

  function injectToggle() {
    // Já injetado?
    if (document.querySelector('.jp-theme-toggle')) return;

    // Tentar anexar ao header — buscar área de ícones (cart, account)
    var iconsList = document.querySelector('.header__icons');
    if (iconsList) {
      var btn = createToggle();
      // Inserir antes do primeiro ícone (search/account/cart)
      iconsList.insertBefore(btn, iconsList.firstChild);
      return;
    }

    // Fallback: anexar ao header genérico
    var header = document.querySelector('.header');
    if (header) {
      var btn2 = createToggle();
      btn2.style.cssText = 'position:absolute;top:8px;right:60px;';
      header.appendChild(btn2);
      return;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectToggle);
  } else {
    injectToggle();
  }
})();


/* ============================================================
   PERF + UX BOOST — Lazy loading + scroll animations
   ============================================================ */
(function() {
  'use strict';
  
  // 1. Lazy loading: forçar loading="lazy" em imagens abaixo da viewport
  function applyLazyLoad() {
    const imgs = document.querySelectorAll('img:not([loading])');
    const viewportHeight = window.innerHeight;
    imgs.forEach(img => {
      const rect = img.getBoundingClientRect();
      // Se imagem não está visível no primeiro fold, lazy load
      if (rect.top > viewportHeight * 1.2) {
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
      } else {
        img.setAttribute('loading', 'eager');
        img.setAttribute('decoding', 'sync');
        img.setAttribute('fetchpriority', 'high');
      }
    });
  }
  
  // 2. Scroll reveal animations
  function setupScrollReveal() {
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('jp-fade-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -50px 0px' }
    );
    
    const targets = document.querySelectorAll(
      '.jp-ben-card, .jp-dep-card, .jp-faq-item, ' +
      '.article-card, .card, .jp-cta, ' +
      '[id*="jp_beneficios"] > *, [id*="jp_depoimentos"] > *'
    );
    targets.forEach(el => observer.observe(el));
  }
  
  // 3. Sticky header on scroll
  function setupStickyHeader() {
    const header = document.querySelector('.header-wrapper, sticky-header');
    if (!header) return;
    let lastScroll = 0;
    let ticking = false;
    
    window.addEventListener('scroll', () => {
      lastScroll = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(() => {
          if (lastScroll > 50) {
            header.classList.add('jp-scrolled');
          } else {
            header.classList.remove('jp-scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }
  
  // 4. Preload imagens críticas no hover (UX boost)
  function setupHoverPreload() {
    document.querySelectorAll('a[href^="/products/"], a[href^="/collections/"]').forEach(link => {
      link.addEventListener('mouseenter', () => {
        if (link.dataset.preloaded) return;
        const preload = document.createElement('link');
        preload.rel = 'prefetch';
        preload.href = link.href;
        document.head.appendChild(preload);
        link.dataset.preloaded = 'true';
      }, { once: true });
    });
  }
  
  // 5. Esconder mensagem de erro inline do navegador em forms
  function fixFormUX() {
    document.querySelectorAll('input[required]').forEach(input => {
      input.addEventListener('invalid', (e) => {
        e.target.classList.add('jp-input-error');
      });
      input.addEventListener('input', (e) => {
        e.target.classList.remove('jp-input-error');
      });
    });
  }
  
  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      applyLazyLoad();
      setupScrollReveal();
      setupStickyHeader();
      setupHoverPreload();
      fixFormUX();
    });
  } else {
    applyLazyLoad();
    setupScrollReveal();
    setupStickyHeader();
    setupHoverPreload();
    fixFormUX();
  }
  
  // Re-aplicar lazy load em conteúdo dinâmico
  if ('MutationObserver' in window) {
    const mo = new MutationObserver(() => applyLazyLoad());
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
